import * as Preact from "preact"

export default function(stage) {
    if(stage?.flags["hud"] == "hidden") {
        return (
            <div class="TutorialPrompt" isHidden={true}/>
        )
    }
    if(stage.currentEncounterKey == "1") {
        if(stage.turn.number >= 4
        || stage.turn.number == 3 && stage.turn.phase == "end") {
            return (
                <div class="TutorialPrompt" size="thin" position="topright">
                    <div class="Text">
                        The eyes in the dark may spawn a monster. Or they may not.
                        <br/><br/>
                        Flee for the doors.
                    </div>
                </div>
            )
        }
        if(stage.flags["tutorial:hasAttacked"] != true) {
            return (
                <div class="TutorialPrompt" size="thin" position="topright">
                    <div class="Text">Monstrosities!! Bury your knife deep within them.</div>
                </div>
            )
        }
        if(stage.flags["tutorial:hasKilled"] == true) {
            return (
                <div class="TutorialPrompt" size="thin" position="topright">
                    <div class="Text">There are sure to be more - we must escape. Flee for the doors.</div>
                </div>
            )
        }
    }

    if(stage.currentEncounterKey == "2") {
        const hurtUnit = Object.values(stage.units).filter((unit) => {
            return unit.isDead != true
                && unit.affiliation == stage.player.affiliation
                && unit.health < unit.maxhealth
        }).sort((a, b) => {
            return (a.health / a.maxhealth) - (b.health / b.maxhealth)
        })[0]
        if(stage.units["priest"].isDead != true
        && stage.units["priest"].isRemoved != true
        && hurtUnit != undefined) {
            if(stage.flags["tutorial:hasHealed"] != true) {
                return (
                    <div class="TutorialPrompt" size="thin" position="topright">
                        <div class="Text">{(hurtUnit.name || hurtUnit.title)} is hurt, but the Priest can heal them.</div>
                    </div>
                )
            } else {
                return (
                    <div class="TutorialPrompt" size="thin" position="topright">
                        <div class="Text">Be warned: the priest can save all but themselves.</div>
                    </div>
                )
            }
        } else if(stage.units["professor"].isDead != true
        && stage.units["professor"].isRemoved != true) {
            return [
                <div class="TutorialPrompt" size="thin" position="topright">
                    <div class="Text">
                        The professor's shots cannot be counterattacked!
                    </div>
                </div>,
                <div class="TutorialPrompt" size="thin" position="bottomright">
                    <div class="Text">
                        ...But nor can he counterattack.
                    </div>
                </div>,
            ]
        }
        // someone is injured and priest is alive, do the healing tutorial
        // tutorialize the gunner not having counterattacks
    }

    if(stage.currentEncounterKey == "3") {
        return (
            <div class="TutorialPrompt" size="thin" position="topright">
                <div class="Text">Flee for the doors, or pray for a swift death.</div>
            </div>
        )
    }

    return (
        <div class="TutorialPrompt" isHidden={true}/>
    )
}
